
















import { api } from '@/api';
import { Template } from '@/types/Template';
import { Video } from '@/types/Video';
import Vue from 'vue';
import { mapGetters } from 'vuex';

export default Vue.extend({
    name: 'Processing',
    data: (): {
        advertising: string;
        state: string;
        snackbar: boolean;
        snackbarMessage: string;
        snackbarColor: string;
        checkInterval?: number;
    } => ({
        advertising: '',
        state: '',
        snackbar: false,
        snackbarMessage: '',
        snackbarColor: 'error',
    }),
    computed: {
        ...mapGetters(['advertisings', 'videos', 'templates', 'records']),
        video(): Video {
            return this.videos.find((video: Video) => video.id.toString() === this.$route.params.id);
        },
        template(): Template {
            return this.templates.find((template: Template) => template.id === this.video.template.id);
        },
        progress(): number {
            if (this.state === 'new') {
                return 0;
            }

            if (this.state === 'queued') {
                return 33;
            }

            if (this.state === 'rendering') {
                return 66;
            }

            return 100;
        },
        progressText(): string {
            if (this.state === 'new') {
                return 'Video processing not started ...';
            }

            if (this.state === 'queued') {
                return 'Video is in the queue, waiting for rendering ...';
            }

            if (this.state === 'rendering') {
                return 'Video will be rendered, waiting for finishing ...';
            }

            if (this.state === 'failed') {
                return 'Video failed to render ... :-(';
            }

            return 'Video is finished ...';
        },
    },
    methods: {
        getRandomAdvertisingUrl(): string {
            if (this.template.video_advertisement) {
                return this.template.video_advertisement;
            }

            if (!this.advertisings.length) {
                return '';
            }

            const index = Math.floor(Math.random() * this.advertisings.length);

            return typeof this.advertisings[index] === 'undefined' ? '' : this.advertisings[index].url;
        },
        showSnackbarMessage(message: string) {
            this.snackbarMessage = message;
            this.snackbar = true;
        },
        close() {
            this.$router.replace('/projects');
        },
    },
    watch: {
        async state(state: string) {
            switch (state) {
                case 'new':
                    await api.get(`/videos/${this.video.id}/render`);
                    await this.$store.dispatch('fetchVideo', this.video);

                    break;
                case 'finished':
                    window.clearInterval(this.checkInterval);
                    this.$router.replace(`/videos/${this.video.id}`);

                    break;
                case 'failed':
                    window.clearInterval(this.checkInterval);

                    break;
                default:
                    window.clearInterval(this.checkInterval);
                    this.checkInterval = window.setTimeout(async () => {
                        await this.$store.dispatch('fetchVideo', this.video);
                    }, 3000);

                    break;
            }
        },
        video(video: Video) {
            this.state = video.state;
        },
    },
    async mounted() {
        await this.$store.dispatch('fetchVideo', this.video);

        if (!this.advertisings.length) {
            await this.$store.dispatch('fetchAdvertisings');
        }

        this.advertising = this.getRandomAdvertisingUrl();
    },
});
